// import { networkNavMenu, referralNavMenu } from "./NavMenus";
import { colleagues, received } from "./common";
import paths from "./paths";
import { ReactComponent as HomeIcon } from '../assets/Icons/home.svg';
import { ReactComponent as UsersIcon } from '../assets/Icons/usersfilled.svg';
import { ReactComponent as ReferralIcon } from '../assets/Icons/referral.svg';
import { ReactComponent as FilledNotificationIcon } from '../assets/Icons/filledNotification.svg';
import { ReactComponent as DarkHomeIcon } from '../assets/Icons/darkHomeIcon.svg';
import { ReactComponent as DarkReferralIcon } from '../assets/Icons/darkReferralIcon.svg';
import { ReactComponent as DarkUsersIcon } from '../assets/Icons/darkUsersIcon.svg';
import { ReactComponent as DarkFilledNotificationIcon } from '../assets/Icons/darkFilledNotificationIcon.svg';
import { ReactComponent as MessageIcon } from '../assets/Icons/chat.svg';
import { ReactComponent as DarkMessageIcon } from '../assets/Icons/chat-filled.svg';
import { ReactComponent as GroupIcon } from '../assets/Icons/groups.svg';
import { ReactComponent as DarkGroupIcon } from '../assets/Icons/groups.svg';

const getNavMenu = (permissions, info) => {
  const allMenus = [
    { id: 1, path: paths.home, text: 'Home', Icon: HomeIcon, DarkIcon: DarkHomeIcon },
    { id: 2, text: 'Network', path: paths.network(colleagues), Icon: UsersIcon, DarkIcon: DarkUsersIcon },
    { id: 5, text: 'Referrals', path: paths.referrals(received), Icon: ReferralIcon, DarkIcon: DarkReferralIcon },
    { id: 6, text: 'Notifications', path: paths.Notifications, Icon: FilledNotificationIcon, DarkIcon: DarkFilledNotificationIcon }
  ];

  if (info?.chat_enabled) {
    allMenus.splice(2, 0,
      { id: 3, text: 'Messages', path: paths.messages, Icon: MessageIcon, DarkIcon: DarkMessageIcon },
      { id: 4, text: 'Discussion Groups', path: paths.groups, Icon: UsersIcon, DarkIcon: DarkUsersIcon }
    );
  }

  return allMenus.filter(menu => {
    if (menu.text === 'Referrals' || menu.text === 'Notifications') {
      return permissions?.notification_update !== false;
    }
    return true;
  });
};

export default getNavMenu;